import React, { useRef, useEffect, useState } from 'react';
import { Cropper, CropperRef } from 'react-advanced-cropper';
import 'react-advanced-cropper/dist/style.css';

import Uppy from '@uppy/core';
import AwsS3Multipart from '@uppy/aws-s3-multipart';
import Button from '../submission_boards/component/Button';
import kitDocumentService from '../services/KitDocumentService';
import { KitDocumentModel } from '../submission_kits/components/KitModels';
import mediaKitService from '../services/MediaKitService';

type Props = {
  kitDocumentModel: KitDocumentModel;
  record_uuid: string;
  maxFileSizeMb: number;
  refreshMediaHandler: () => void;
  dialogCloseHandler: () => void;
};

export default function CropImage({
  kitDocumentModel,
  record_uuid,
  maxFileSizeMb,
  refreshMediaHandler,
  dialogCloseHandler,
}: Props) {
  const cropperRef = useRef<CropperRef>(null);
  const [kitDocumentModelSelected, setKitDocumentModelSelected] = useState<KitDocumentModel|null>(null);
  // const [imageUrlSelected, setImageUrlSelected] = useState<string | null>(null);
  const uppy = useRef<Uppy | null>(null);
  const [zoomLevel, setZoomLevel] = useState(1); // zoom scale (2 = center of 1-3 range)
  const [isSaving, setIsSaving] = useState(false);
  const imgRef = useRef(null);
  const [status, setStatus] = useState('Awaiting image load...');

  // Fetch existing image URL from Rails
  // useEffect(() => {
  //   if (imageUrlSelected != null) {
  //     console.log(imageUrlSelected ?? 'null');
  //     console.log(imageName);
  //   }
  // }, [imageUrlSelected]);
  useEffect(() => {
    return () => {
      if (cropperRef.current) {
        cropperRef.current.clear();
      }
    };
  }, []);

  useEffect(() => {
    if (kitDocumentModelSelected == null) {
      return;
    }
    // setImageUrlSelected(kitDocumentModel.file_url);
    let allowedTypes = [];
    allowedTypes.push('image/*');
    if (maxFileSizeMb == undefined || maxFileSizeMb <= 0) {
      maxFileSizeMb = 5;
    }
    if (uppy.current == null) {
      uppy.current = new Uppy({
        debug: false, // Set to false in production. syca_check
        autoProceed: false, // We'll manually trigger upload
        restrictions: {
          maxNumberOfFiles: 1,
          maxFileSize: maxFileSizeMb * 1024 * 1024, // 100MB (adjust as needed)
          allowedFileTypes: allowedTypes,
        },
      });
      uppy.current.use(AwsS3Multipart, {
        companionUrl: '/',
        // createMultipartUploadUrl: '/rails/active_storage/direct_uploads',
      });

      uppy.current.on('upload-success', async (file, response) => {
        // const { meta } = response;
        // const blobSignedId = meta.signed_id;
        console.log('Uppy upload-success:', file, response);
        const category_id = kitDocumentModelSelected.category_id;
        const mediakit_uuid: string = record_uuid;
        const kit_document_uuid: string = kitDocumentModelSelected.uuid;
        console.log('Uppy upload-success kitDocumentService.updateKitDocument start');
        await kitDocumentService.updateKitDocument(
          file,
          category_id,
          mediakit_uuid,
          kit_document_uuid,2
        );
        refreshMediaHandler();
        console.log('Uppy upload-success kitDocumentService.updateKitDocument end');
        // Update existing Image record with new file
        // await fetch(`/images/${imageId}`, {
        //   method: 'PUT',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify({
        //     image: { file: blobSignedId },
        //   }),
        // }).then(async (res) => {
        //   const data = await res.json();
        //   setImageUrlSelected(data.url); // refresh preview with new file
        // });
      });

      uppy.current.on('error', (err) => {
        console.error('Uppy error:', err);
      });
    }
    // })();
  }, [kitDocumentModelSelected]);

  // useEffect(() => {
  //   if (kitDocumentModel == null) {
  //     return;
  //   }

  //   setKitDocumentModelSelected(kitDocumentModel);
  // }, [kitDocumentModel]);
  
  // get signed aws url
  useEffect(() => {
    if (kitDocumentModel == null) {
      return;
    }
    async function load() {
      // const realUrl = await resolveActiveStorageUrl(kitDocumentModel.file_url);
      // // kitDocumentModel.file_url = realUrl;
      // if(realUrl != null) {
      // const model = {
      //   ...kitDocumentModel,
      //   file_url : realUrl
      // };
      // setKitDocumentModelSelected(model);
      // }
      //  else {
      // setKitDocumentModelSelected(kitDocumentModel);
      //  }
      setKitDocumentModelSelected(kitDocumentModel);
      
    }

    load();
  }, [kitDocumentModel]);

  // const resolveActiveStorageUrl = async (url) => {
  //   const response = await mediaKitService.mediaBlogToAwsUrl(url)
  //   // const response = await fetch(url, {
  //   //   method: 'GET',
  //   //   redirect: 'follow',
  //   //   // credentials: 'omit',
  //   // });
  //   console.log("resolveActiveStorageUrl", response);
  //   if(response == null || response?.request?.responseURL == undefined) {
  //     return null;
  //   }
  //   return response.request.responseURL;
  // }

  const handleReCrop = async () => {
    try {
      if (!cropperRef.current) return;

      const canvas = cropperRef.current.getCanvas();
      if (!canvas) return;

      canvas.toBlob(async (blob) => {
        if (!blob) return;

        if (uppy.current) {
          const file = new File([blob], kitDocumentModelSelected.file_name, { type: kitDocumentModelSelected.file_content_type });
          console.log('add in uppy');
          uppy.current.cancelAll();
          uppy.current.addFile({
            name: file.name,
            type: file.type,
            data: file,
          });
          setIsSaving(true);
          try {
            //   setErrorMessage('');
            // setUploadComplete(false);
            console.log('uppy upload started');
            await uppy.current.upload(); // Start the upload process
            console.log('uppy upload ended');
          } catch (error) {
            //   setErrorMessage(
            //     'Error in uploading media. Please check your internet or try again later.'
            //   );
            console.log('Error in uploading, check internet connection', error);
          } finally {
            setIsSaving(false);
          }
        }
      }, 'image/png');
    } catch (error) {
    } finally {
      setIsSaving(false);
    }
  };
  const onCloseDialog = () => {
    dialogCloseHandler();
  };
  const flip = (horizontal: boolean, vertical: boolean) => {
    if (cropperRef.current) {
      cropperRef.current.flipImage(horizontal, vertical);
    }
  };
  const rotate = (angle: number) => {
    if (cropperRef.current) {
      cropperRef.current.rotateImage(angle);
    }
  };
  //   const zoom = () => {
  //     if (cropperRef.current) {
  //       cropperRef.current.zoomImage(2); // zoom-in 2x
  //     }
  //   };
  const move = () => {
    if (cropperRef.current) {
      cropperRef.current.moveImage(50, 100); // move x = 50, y = 100
    }
  };
  const handleZoomChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newZoom = parseFloat(e.target.value);
    console.log('handleZoomChange newZoom:', newZoom);

    setZoomLevel(newZoom);
    if (cropperRef.current) {
      cropperRef.current.zoomImage(newZoom / zoomLevel); // apply relative zoom factor
    }
  };

  // useEffect(() => {
  //   if (!imgRef.current) return;

  //   const imageElement = imgRef.current;

  //   // This is the CRITICAL part. We define a handler that guarantees
  //   // the image data is fully available in the browser's memory.
  //   const handleImageLoad = () => {
  //     setStatus('Image fully loaded. Initializing Cropper...');

  //     // Initialization happens *only* after the 'load' event fires.
  //     if (cropperRef.current) {
  //       cropperRef.current.clear();
  //     }
  //     cropperRef.current = new Cropper(imageElement, {
  //     });
  //     setStatus('Cropper initialized successfully!');
  //   };

  //   // The race condition happens if you initialize Cropper.js here:
  //   // if (imageElement.complete) { // Might be true, but often too early for large images
  //   //    cropperRef.current = new Cropper(imageElement, {}); // Timing Failure
  //   // } else {
  //   //    imageElement.onload = handleImageLoad;
  //   // }

  //   // --- The robust pattern: Listen for the load event. ---

  //   // Check if the image is already complete (browser cache hit)
  //   if (imageElement.complete) {
  //     handleImageLoad();
  //   } else {
  //     // If not complete, attach the event listener
  //     imageElement.onload = handleImageLoad;
  //   }

  //   // Clean up the onload handler if the component unmounts quickly
  //   return () => {
  //     imageElement.onload = null;
  //   };
  // }, [imgRef]);
  
  useEffect(() => {
    console.log('zoomLevel', zoomLevel);
  }, [zoomLevel])
  const readCurrentZoom = () => {
    const cropper = cropperRef.current;
    if (!cropper) return null;
    const state = cropper.getState();
    if (!state || !state.visibleArea) return null;
    const imageWidth = state.imageSize.width;
    const visibleWidth = state.visibleArea.width;
    return imageWidth / visibleWidth; // current zoom factor (1x, 2x...)
  };

  const setZoomTo = (targetZoom: number) => {
    const cropper = cropperRef.current;
    if (!cropper) return;
    const state = cropper.getState();
    if (!state || !state.visibleArea) return;

    const imageWidth = state.imageSize.width;
    const currentVisibleWidth = state.visibleArea.width;
    const desiredVisibleWidth = imageWidth / targetZoom;

    // relative factor for zoomImage (example: zoomImage(2) -> zoom in 2x)
    const relativeFactor = currentVisibleWidth / desiredVisibleWidth;

    cropper.zoomImage(relativeFactor, { transitions: true });
    setZoomLevel(targetZoom);
  };
  return (
    <div className="w-full h-full flex flex-col gap-5">
      {kitDocumentModelSelected ? (
        <>
          {/* <img
            ref={imgRef}
            id="cropper-target"
            src={kitDocumentModelSelected.file_url}
            alt="Image to be cropped"
            // className="max-w-full h-auto block"
          /> */}
          {/* <img src={imageUrlSelected} alt={imageName} /> */}
          {status != '' && <div>{status}</div>}
          <Cropper
            ref={cropperRef}
            src={kitDocumentModelSelected.file_url_proxy || kitDocumentModelSelected.file_url}
            crossOrigin="anonymous"
            stencilProps={{ aspectRatio: 4 / 5 }}
            className="cropper"
            onReady={(cropperObj: any) => {
              console.log(cropperObj);
              setStatus('');
              // Set zoom to center (2) when image loads
              setTimeout(() => {
                setZoomTo(1);
              }, 100);
              // const cropper = cropperRef.current;
              // if (cropper) {
              //   const image = cropper.getImage();
              //   const visibleArea = cropper.getVisibleArea();

              //   if (image && visibleArea) {
              //     // Ratio between visible (shown) size and original image size
              //     const scaleX = image.width / visibleArea.width;
              //     const scaleY = image.height / visibleArea.height;

              //     const displayWidth = image.width / scaleX;
              //     const displayHeight = image.height / scaleY;

              //     console.log('Real image size:', image.width, 'x', image.height);
              //     console.log('Displayed size (on screen):', displayWidth, 'x', displayHeight);
              //   }
              // }
            }}
            onError={(cropperObj: any) => {
              console.error('Cropper error:', cropperObj);
              setStatus('Unable to load image. Please try again.');
            }}
            onUpdate={(cropperObj: any) => {
              const z = readCurrentZoom();
              if (z) setZoomLevel(z);

              // if (cropperObj) {
              //   const coordinates = cropperObj.getCoordinates();
              //   if (coordinates && cropperObj.getCanvas()?.width) {
              //     const newZoom = parseFloat(
              //       (coordinates.width / cropperObj.getCanvas()?.width).toFixed(2)
              //     ); // Example calculation
              //     if (!Number.isNaN(newZoom) && newZoom != zoomLevel) {
              //       console.log('Cropper newZoom:', newZoom);
              //       setZoomLevel(newZoom); // Format for display
              //     }
              //   }
              // }

              // const cropper = cropperRef.current;
              // if (cropper) {
              //   const image = cropper.getImage();
              //   const visibleArea = cropper.getVisibleArea();

              //   if (image && visibleArea) {
              //     // Ratio between visible (shown) size and original image size
              //     const scaleX = image.width / visibleArea.width;
              //     const scaleY = image.height / visibleArea.height;

              //     const displayWidth = image.width / scaleX;
              //     const displayHeight = image.height / scaleY;

              //     console.log('Real image size:', image.width, 'x', image.height);
              //     console.log('Displayed size (on screen):', displayWidth, 'x', displayHeight);
              //   }
              // }
            }}
          />
          <div style={{ marginTop: '10px' }}>
            {/* <label>Zoom: </label> */}
            <input
              style={{ height: '3px' }}
              className="w-full bg-blue-201"
              type="range"
              min="1"
              max="3"
              step="0.1"
              value={zoomLevel}
              onChange={(e) => setZoomTo(parseFloat(e.target.value))}
              // onChange={handleZoomChange}
            />
            {/* <span>{zoom.toFixed(1)}x</span> */}
          </div>
        </>
      ) : (
        <p>Loading image...</p>
      )}
      <div className=" text-center pt-4 flex flex-row justify-center gap-2 items-center">
        <Button
          id="cancel_sbadd_btn_id"
          variant="secondary"
          btn_size="small"
          icon_position="hor"
          disabled={isSaving}
          onClick={() => {
            onCloseDialog();
          }}
        >
          <span className="truncate" style={{ maxWidth: '10rem' }}>
            Cancel
          </span>
        </Button>
        <Button
          id="submit_sbadd_btn_id"
          variant="primary"
          btn_size="small"
          icon_position="hor"
          type="button"
          disabled={isSaving}
          onClick={() => {
            handleReCrop();
          }}
        >
          <span className="truncate" style={{ maxWidth: '10rem' }}>
            {isSaving ? 'Saving' : 'Save'}
          </span>
        </Button>
      </div>
    </div>
  );
}
